module.exports = __webpack_public_path__ + "img/download-2-3.f8448bbe.png";